module.exports = __webpack_public_path__ + "img/arrow-left.fcfc92e4.png";